/**
 * Demo / fallback feed.
 *
 * The real feed lives behind `https://tgcdn.xsoda.net` and is only reachable
 * from inside the native shell (and is age-gated). So that the redesigned UI
 * is runnable in a plain browser, `useVideoFeed` falls back to this curated
 * list of public HLS test streams when the live API can't be reached.
 */
import { seedReactions } from './content.js';

const STREAMS = [
  {
    id: 'demo-bbb',
    title: 'Big Buck Bunny · open movie',
    author: 'blender',
    caption: 'A classic open-source short. Smooth gradients, perfect for testing. #demo',
    playlist:
      'https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8',
    accent: 'linear-gradient(140deg,#ff5f6d,#ffc371)',
  },
  {
    id: 'demo-sintel',
    title: 'Sintel · trailer',
    author: 'blender',
    caption: 'Epic fantasy short by the Blender Foundation. #cinema #vizos',
    playlist:
      'https://bitdash-a.akamaihd.net/content/sintel/hls/playlist.m3u8',
    accent: 'linear-gradient(140deg,#6a0dad,#b94bdf)',
  },
  {
    id: 'demo-tears',
    title: 'Tears of Steel',
    author: 'mango',
    caption: 'Sci-fi VFX showcase. Save it to your favorites! ⭐',
    playlist:
      'https://test-streams.mux.dev/test_001/stream.m3u8',
    accent: 'linear-gradient(140deg,#0093E9,#80D0C7)',
  },
  {
    id: 'demo-apple',
    title: 'Apple BipBop · advanced',
    author: 'apple',
    caption: 'Reference adaptive stream. Double-tap to like ❤️',
    playlist:
      'https://devstreaming-cdn.apple.com/videos/streaming/examples/img_bipbop_adv_example_ts/master.m3u8',
    accent: 'linear-gradient(140deg,#f857a6,#ff5858)',
  },
];

export function buildMockFeed() {
  return {
    feed: { cdnUrl: '', cdnPath: '', imageBase: '' },
    items: STREAMS.map((s) => ({
      id: s.id,
      title: s.title,
      author: s.author,
      caption: s.caption,
      playlist: s.playlist,
      accent: s.accent,
      reactions: seedReactions(),
    })),
  };
}
